export default __webpack_public_path__ + "static/media/Okay.a968ad20.svg";